<template>
  <div class="w-10/12">
    <div class="w-full" v-if="!showError">
      <div class="flex flex-col">
        <div class="w-full">
          <Tab :tabs="$store.state.subscription && $store.state.subscription.plan === 'basic'
              ? basicTab
              : tabs
            " 
            border 
            :active-tab="currentTab" 
            @currentTab="currentTab = $event" />
        </div>
        <div style="height: 100%" v-if="loading">
          <loader size="xxs" :loader-image="false" />
        </div>
        <div v-else class="mt-7 flex-grow">
          <pay-settings v-if="currentTab === 'Payroll Settings'"
            :employee-details="employeeDetails"
            :other-benefit-data="otherBenefitData"
            @edit-RateValue="editRateValue"
          />
          <annual-gross v-if="currentTab === 'Salary Breakdown'" :revise-salary="reviseSalary"
            :total-gross-earning="totalGrossEarning"
            :expected-net-pay="expectedNetPay" :expected-nhf-pay="expectedNhfPay"
            :expected-paye-pay="expectedPayePay" :expected-pension-pay="expectedPensionPay"
            :expected-nhis-pay="expectedNhisPay"
            :expected-wht-amount="expectedWhtAmount"
            @grossPay="getPaysettings()"
          />
          <!-- <other-benefits v-if="$store.state.subscription && $store.state.subscription.plan === 'basic' 
            && currentTab === 'Other Benefits'" :other-benefit-data="otherBenefitData"
            @submit="getPaysettings()" @edit-RateValue="editRateValue"
          /> -->
          <work-hours v-if="currentTab === 'Work Hours'" />
          <account-info v-if="currentTab === 'Remittance Accounts'" />
          <pay-analytics v-if="currentTab === 'Pay Analytics'" :user-details="employeeDetails" />
        </div>
        <!-- <divider class="my-8" /> -->
        <div class="flex mb-5">
          <div class="flex mt-4 flex-grow"></div>
        </div>
      </div>
    </div>
    <error-page v-if="showError" />
  </div>
</template>

<script>
import Tab from "@scelloo/cloudenly-ui/src/components/tab";
import { mapState } from "vuex";

import Divider from "@/components/divider";
import PaySettings from "./paySettings";
import AccountInfo from "./accountInfo";
import OtherBenefits from "./otherBenefits";
import AnnualGross from "./annualGross";
import WorkHours from "./workHours";
import PayAnalytics from "./payAnalytics";
import ErrorPage from "@/modules/Admin/error403";

export default {
  name: "PayInfo",
  components: {
    Divider,
    Tab,
    PaySettings,
    AnnualGross,
    AccountInfo,
    OtherBenefits,
    WorkHours,
    PayAnalytics,
    ErrorPage
  },
  data() {
    return {
      states: [],
      loading: true,
      currentTab: "Payroll Settings",
      grossEarningsData: [],
      annualGrossPay: "",
      totalGrossEarning: 0,
      otherBenefitData: [],
      reviseSalary: {},
      tabs: [],
      showError: false,
      expectedNetPay: 0,
      expectedNhfPay: 0,
      expectedPayePay: 0,
      expectedPensionPay: 0,
      expectedNhisPay: 0,
      expectedWhtAmount: 0,
      basicTab: ["Payroll Settings", "Salary Breakdown", "Remittance Accounts"],
    };
  },
  methods: {
    editRateValue(index) {
      const items = this.otherBenefitData;
      if (index < 0 || index >= items.length) return;

      items[index].isEdit = !items[index].isEdit;
      if(items[index].isEdit === false){
        const paySetting = { paysettings: [
          {
            paySettingId: items[index].paySettingId,
            employeeId: this.employeeDetails.id,
            rateValue: items[index].rateValue
          }
        ] };
        this.$_saveEmployeepayItem(paySetting).then(() => {
          this.$toasted.success("Rate value updated successfully", { duration: 5000 });
        }).catch(()=> {
           this.$toasted.error("Error updating rate value", {
              duration: 5000
            });
        });
      }
    },
    getPaysettings() {
      this.$_getEmployeePaySetting({
        employeeId: this.employeeDetails.id,
      }).then((result) => {
        const {
          annualGrossEarnings,
          expectedNetPay,
          expectedNhfPay,
          expectedPayePay,
          expectedPensionPay,
          expectedNhisPay,
          expectedWhtAmount,
          otherEarnings,
          grossEarningsTotalAmount,
          otherEarningsTotalAmount,
          totalGross,
          reviseSalary,
        } = result.data;
        this.grossEarningsData = annualGrossEarnings;
        this.expectedNetPay = expectedNetPay;
        this.expectedNhfPay = expectedNhfPay;
        this.expectedPayePay = expectedPayePay;
        this.expectedPensionPay = expectedPensionPay;
        this.expectedNhisPay = expectedNhisPay;
        this.expectedWhtAmount = expectedWhtAmount;
        // this.otherBenefitData = otherEarnings;
        this.otherBenefitData = otherEarnings?.map(item => ({ ...item, isEdit: false }));
        this.totalOtherEarning = otherEarningsTotalAmount;
        this.totalGrossEarning = { grossEarningsTotalAmount, totalGross };
        this.reviseSalary = reviseSalary;
        this.loading = false;
      });
    },
  },
  computed: {
    ...mapState({
      employeeDetails: (state) => state.employee.allEmployeeDetails,
    }),
    currentT(){
      return this.currentTab
    }
  },

  async mounted() {
    try {
      if (!this.$route.query.slug) {
        await this.$handlePrivilege(
          "employeeDirectory",
          "viewEmployeePayInfo"
        );
      }
      await this.getPaysettings();
      this.$store.dispatch("employee/getOneEmployeeAll", this.$route.params.id);
    } catch (error) {
      this.showError = true;
    }
  },

  created() {
    this.tabs = [
      "Payroll Settings",
      "Salary Breakdown",
      "Work Hours",
      "Remittance Accounts",
      "Pay Analytics",
    ];
  },
};
</script>

<style lang="scss" scoped>
.payInfo {
  display: flex;
  flex-direction: row;
  align-items: center;
  border-style: solid;
  border-width: 1px;
  border-radius: 5px;

  &_fakeInput {
    background: #f7f7ff;
    border-color: #878e99;
    padding: 10px 15px;
    max-height: 40px;
  }

  &_disabled {
    padding: 10px 15px;
    min-height: 40px;
    background: #eeeeee;
    border-color: #878e99;
  }

  &_unallocated {
    padding: 12px 16px;
    background: #fff5f5;
    border-color: #ea3c53;
    max-height: 65px;
  }
}
</style>
